import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    default: {
        backgroundColor: "#7a9bc2",
        color: '#000000',
    },
    warning: {
        backgroundColor: "#cf7f00",
        color: '#000000',
    },
    error: {
        backgroundColor: "#bf2e2e",
        color: '#ffffff',
    },
    success: {
        backgroundColor: "#82c341",
        color: '#000000',
    },
    whiteIcon: {
        color: '#ffffff'
    },
    White: {
        color: "#fff"
    }
}));
